<template>
  <button
    class="theme-toggle"
    :class="{ 'is-dark': isDark }"
    @click="toggleTheme"
    :aria-label="isDark ? 'Zu Light Mode wechseln' : 'Zu Dark Mode wechseln'"
    :title="isDark ? 'Light Mode' : 'Dark Mode'"
  >
    <span class="theme-toggle__icon theme-toggle__icon--sun">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="5" />
        <line x1="12" y1="1" x2="12" y2="3" />
        <line x1="12" y1="21" x2="12" y2="23" />
        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
        <line x1="1" y1="12" x2="3" y2="12" />
        <line x1="21" y1="12" x2="23" y2="12" />
        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
      </svg>
    </span>
    <span class="theme-toggle__icon theme-toggle__icon--moon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
      </svg>
    </span>
    <span class="theme-toggle__slider" />
  </button>
</template>

<script>
/**
 * ThemeToggle - Light/Dark Mode switch component
 * @description Toggles between light and dark theme with localStorage persistence
 */
export default {
  name: "ThemeToggle",
  data() {
    return {
      isDark: false,
    };
  },
  methods: {
    /**
     * Toggles the current theme and persists to localStorage
     */
    toggleTheme() {
      this.isDark = !this.isDark;
      this.applyTheme();
      this.saveTheme();
    },
    /**
     * Applies the current theme to the document
     */
    applyTheme() {
      document.documentElement.setAttribute(
        "data-theme",
        this.isDark ? "dark" : "light"
      );
    },
    /**
     * Saves the current theme preference to localStorage
     */
    saveTheme() {
      try {
        localStorage.setItem("kemaris-theme", this.isDark ? "dark" : "light");
      } catch (e) {
        console.warn("[ThemeToggle] Could not save theme preference:", e);
      }
    },
    /**
     * Loads the theme preference from localStorage or system preference
     */
    loadTheme() {
      try {
        const saved = localStorage.getItem("kemaris-theme");
        if (saved) {
          this.isDark = saved === "dark";
        } else {
          // Check system preference
          this.isDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        }
      } catch (e) {
        console.warn("[ThemeToggle] Could not load theme preference:", e);
        this.isDark = false;
      }
      this.applyTheme();
    },
  },
  mounted() {
    this.loadTheme();
    
    // Listen for system preference changes
    window
      .matchMedia("(prefers-color-scheme: dark)")
      .addEventListener("change", (e) => {
        if (!localStorage.getItem("kemaris-theme")) {
          this.isDark = e.matches;
          this.applyTheme();
        }
      });
  },
};
</script>
